export default "__VITE_ASSET__Dkc3I7Sy__"